export default __webpack_public_path__ + "3401d7a329627fc15c477c32d3774837.png";